export default {
    conectado:            false,
    whatChimpAuth:        null,
    whatChimpConnecting:  false,
    whatChimpError:       null,
    whatsappTemplates: [],
    whatsappVariables: [],
}


// WEBPACK FOOTER //
// ./src/modules/whatChimpApi/state.js